import ReactEcharts from "echarts-for-react";

export function BarChart({ style, dados }) {
  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: "{b}<br/> <strong>{c}%</strong>",
    },
    xAxis: {
      type: "category",
      data: dados.map((item) => {
        return item.name;
      }),
      axisLabel: {
        interval: 0,
        rotate: 40,
        fontSize: "1rem",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}%",
      },
    },
    visualMap: {
      show: false,
      inRange: {
        color: ["#90CBF0", "#0B4F6C"],
      },
      min: dados[dados.length - 1].value,
      max: dados[0].value,
    },
    grid: {
      left: "3%",
      right: "0%",
      bottom: "3%",
      top: "14%",
      containLabel: true,
    },
    series: [
      {
        data: dados,
        type: "bar",
        label: {
          show: true,
          position: "inside",
          formatter: "{c}%",
          fontSize: "1.5rem",
          fontWeight: "bold",
        },
      },
    ],
  };

  return <ReactEcharts option={option} style={style} />;
}
